import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Inject, Component, ViewChild } from '@angular/core';
import { Global } from './global';

@Component({
    selector: 'asap-edit',
    templateUrl: 'asap-edit.component.html',
    styleUrls: ['./asap.component.css'],

})
export class AsapEditComponent {

    public entity;
    public fields;
    public owner;
    public project = false;
    public display = false;
    public Title = '';


    constructor(
        public dialogRef: MatDialogRef<AsapEditComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        public global: Global,
    ) {

        this.owner = data.owner;
        this.fields = this.owner.tableDef();
        this.entity = this.owner.entity;

        if (Object.keys(this.entity).length === 0) {
            this.project = true;
            this.display = true;
            this.Title = 'Criar uma sessão';
        } else {
            this.project = false;
            this.Title = 'Criar projeto';
        }
    }



    public close(): void {
        this.dialogRef.close();
    }

}



// WEBPACK FOOTER //
// ./src/app/@core/lib/asap-edit.component.ts